import { type HeadlineMetrics } from "../../api/generated";
import { LeadHeadLineMetricsTranslatedContent } from "../types";
import { LeadsInfoCard } from "./LeadsInfoCard";
import { LeadsInfoDashboardSkeleton } from "./LeadsInfoDashboardSkeleton";

type HeadlineMetricsKey = "profileCreated" | "onboarding" | "approved";

export type LeadStaticHeadlineMetricData = {
  key: HeadlineMetricsKey;
  title?: string;
  tooltip?: string;
  onHover?: (isMobile: boolean) => void;
  value?: number;
  changeInPercent?: number;
};

type LeadsInfoDashboardProps = {
  data: HeadlineMetrics | undefined;
  isLoading: boolean;
  translatedContent?: LeadHeadLineMetricsTranslatedContent;
  onTrackInProgressTooltipHover?: (isMobile: boolean) => void;
  isMobile?: boolean;
};

export const LeadsInfoDashboard = ({
  data,
  isLoading,
  translatedContent,
  onTrackInProgressTooltipHover,
  isMobile = false,
}: LeadsInfoDashboardProps) => {
  const transformedHeadlineMetrics: LeadStaticHeadlineMetricData[] = [
    {
      key: "profileCreated",
      title: translatedContent?.profileCreated,
      value: data?.profileCreated?.value ?? 0,
      changeInPercent: data?.profileCreated?.changeInPercent ?? 0,
    },
    {
      key: "onboarding",
      title: translatedContent?.onboarding,
      tooltip: translatedContent?.onboardingTooltip,
      value: data?.onboarding?.value ?? 0,
      changeInPercent: data?.onboarding?.changeInPercent ?? 0,
      onHover: onTrackInProgressTooltipHover,
    },
    {
      key: "approved",
      title: translatedContent?.approved,
      value: data?.approved?.value,
      changeInPercent: data?.approved?.changeInPercent,
    },
  ];

  if (isLoading) {
    return <LeadsInfoDashboardSkeleton translatedContent={translatedContent} />;
  }

  return (
    <div className={`flex gap-6 ${isMobile ? "flex-col" : "flex-row"}`}>
      {transformedHeadlineMetrics.map((stat, index) => (
        <LeadsInfoCard
          key={index}
          title={stat.title ?? ""}
          value={stat.value ?? 0}
          changeInPercent={stat.changeInPercent ?? 0}
          change={translatedContent?.headlineMetricsChange || ""}
          tooltipLabel={stat.tooltip}
          onHover={() => {
            stat.onHover?.(isMobile);
          }}
          isMobile={isMobile}
        />
      ))}
    </div>
  );
};
